export type LightConfiguration = {
  angle: "bow" | "port" | "starboard" | "stern" | "around" | "daymark";
  imgSrc: string;
  description: string;
};

export type ShipType = {
  type: string;
  label: string;
  lightConfigurations: LightConfiguration[];
};

export type QuizOption = {
  id: string;
  shipType: string;
  shipLabel: string;
  description: string;
};

export type QuizQuestion = {
  id: string;
  imgSrc: string;
  correctAnswerId: string;
  options: QuizOption[];
};

export type FlatLight = {
  id: string;
  shipType: string;
  shipLabel: string;
  angle: LightConfiguration["angle"];
  imgSrc: string;
  description: string;
};


export const ShipLightsData: ShipType[] = [
  {
    type: "motorboat",
    label: "Motorboot",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Motorboat/bow",
        description: "Motorboot boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Motorboat/starboard",
        description: "Motorboot stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Motorboat/port",
        description: "Motorboot bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Motorboat/stern",
        description: "Motorboot hek ",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/Motorboat/bow_big",
        description: "Motorboot groter of kleinder dan 50m boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Motorboat/starboard_big",
        description: "Motorboot groter of kleinder dan 50m stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Motorboat/port_big",
        description: "Motorboot groter of kleinder dan 50m bakboord",
      },
    ],
  },
  {
    type: "fastship",
    label: "Snel Schip",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Fastship/bow",
        description: "Snel schip boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Fastship/starboard",
        description: "Snel schip stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Fastship/port",
        description: "Snel schip bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Fastship/stern",
        description: "Snel schip hek ",
      },
    ],
  },
  {
    type: "emergencyship",
    label: "Hulpdiensten Schip",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Emergencyship/bow",
        description: "Hulpdiensten Schip boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Emergencyship/starboard",
        description: "Hulpdiensten Schip stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Emergencyship/port",
        description: "Hulpdiensten Schip bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Emergencyship/stern",
        description: "Hulpdiensten Schip hek ",
      },
    ],
  },
  {
    type: "sailboat_small",
    label: "Kleine zeilboot",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Sailboat_small/bow",
        description: "Kleine zeilboot boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Sailboat_small/starboard",
        description: "Kleine zeilboot stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Sailboat_small/port",
        description: "Kleine zeilboot bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Sailboat_small/stern",
        description: "Kleine zeilboot hek",
      },
    ],
  },
  {
    type: "sailboat_big",
    label: "Groot zeilship",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Sailboat_big/bow",
        description: "Groot zeilship boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Sailboat_big/starboard",
        description: "Groot zeilship stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Sailboat_big/port",
        description: "Groot zeilship bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Sailboat_big/stern",
        description: "Groot zeilship hek",
      },
    ],
  },
  {
    type: "sailboat_big",
    label: "Kleine zeilboot",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Sailboat_big/bow",
        description: "Groot zeilship boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Sailboat_big/starboard",
        description: "Groot zeilship stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Sailboat_big/port",
        description: "Groot zeilship bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Sailboat_big/stern",
        description: "Groot zeilship hek",
      },
    ],
  },
  {
    type: "tug_200m",
    label: "Sleepboot (Sleep langer dan 200m)",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Tug_200m/bow",
        description: "Sleepboot (Sleep langer dan 200m) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Tug_200m/starboard",
        description: "Sleepboot (Sleep langer dan 200m) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Tug_200m/port",
        description: "Sleepboot (Sleep langer dan 200m) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Tug_200m/stern",
        description: "Sleepboot (Sleep langer dan 200m) hek",
      },
    ],
  },
  {
    type: "tug",
    label: "Sleepboot (Sleep korter dan 200m)",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Tug/bow",
        description: "Sleepboot (Sleep korter dan 200m) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Tug/starboard",
        description: "Sleepboot (Sleep korter dan 200m) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Tug/port",
        description: "Sleepboot (Sleep korter dan 200m) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Tug/stern",
        description: "Sleepboot (Sleep korter dan 200m) hek",
      },
    ],
  },
  {
    type: "trawler",
    label: "Trailervisser",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Trawler/bow",
        description: "Trailervisser (kleiner dan 50m, geen netten) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Trawler/starboard",
        description: "Trailervisser (kleiner dan 50m, geen netten) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Trawler/port",
        description: "Trailervisser (kleiner dan 50m, geen netten) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Trawler/stern",
        description: "Trailervisser (kleiner dan 50m, geen netten) hek",
      },

      {
        angle: "bow",
        imgSrc: "/Assets/Trawler/bow_50m",
        description: "Trailervisser (langer of kleiner dan 50m, geen netten) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Trawler/starboard_50m",
        description: "Trailervisser (langer of kleiner dan 50m, geen netten) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Trawler/port_50m",
        description: "Trailervisser (langer of kleiner dan 50m, geen netten) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Trawler/stern_50m",
        description: "Trailervisser (langer of kleiner dan 50m, geen netten) hek",
      },

      {
        angle: "bow",
        imgSrc: "/Assets/Trawler/bow_50m_deploying",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het uitzetten) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Trawler/starboard_50m_deploying",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het uitzetten) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Trawler/port_50m_deploying",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het uitzetten) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Trawler/stern_50m_deploying",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het uitzetten) hek",
      },

      {
        angle: "bow",
        imgSrc: "/Assets/Trawler/bow_50m_retracting",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het inhalen) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Trawler/starboard_50m_retracting",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het inhalen) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Trawler/port_50m_retracting",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het inhalen) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Trawler/stern_50m_retracting",
        description: "Trailervisser (langer of kleiner dan 50m, netten aan het inhalen) hek",
      },

      {
        angle: "bow",
        imgSrc: "/Assets/Trawler/bow_50m_caught",
        description: "Trailervisser (langer of kleiner dan 50m, netten zitten vast) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Trawler/starboard_50m_caught",
        description: "Trailervisser (langer of kleiner dan 50m, netten zitten vast) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Trawler/port_50m_caught",
        description: "Trailervisser (langer of kleiner dan 50m, netten zitten vast) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Trawler/stern_50m_caught",
        description: "Trailervisser (langer of kleiner dan 50m, netten zitten vast) hek",
      },
    ],
  },
  {
    type: "fisher",
    label: "Visser (geen trailervisser)",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Fisher/bow",
        description: "Visser (geen trailervisser) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Fisher/starboard",
        description: "Visser (geen trailervisser) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Fisher/port",
        description: "Visser (geen trailervisser) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Fisher/stern",
        description: "Visser (geen trailervisser) hek",
      },
    ],
  },
  {
    type: "pilot",
    label: "Loodsboot",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Pilot/bow",
        description: "Loodsboot (dienstdoend) boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Pilot/starboard",
        description: "Loodsboot (dienstdoend) stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Pilot/port",
        description: "Loodsboot (dienstdoend) bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Pilot/stern",
        description: "Loodsboot (dienstdoend) hek",
      },

      {
        angle: "around",
        imgSrc: "/Assets/Pilot/anchored",
        description: "Loodsboot (dienstdoend, voor anker) rondom",
      },
    ],
  },
  {
    type: "CBD",
    label: "Beperkt manouvreerbaar door diepgang",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/CBD/bow",
        description: "Beperkt manouvreerbaar door diepgang boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/CBD/starboard",
        description: "Beperkt manouvreerbaar door diepgang stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/CBD/port",
        description: "Beperkt manouvreerbaar door diepgang bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/CBD/stern",
        description: "Beperkt manouvreerbaar door diepgang hek",
      },
      {
        angle: "daymark",
        imgSrc: "/Assets/CBD/daymark",
        description: "Dagmerk Beperkt manouvreerbaar door diepgang hek",
      },
    ],
  },
  {
    type: "NUC",
    label: "Onmanouvreerbaar",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/NUC/bow",
        description: "Onmanouvreerbaar boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/NUC/starboard",
        description: "Onmanouvreerbaar stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/NUC/port",
        description: "Onmanouvreerbaar bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/NUC/stern",
        description: "Onmanouvreerbaar hek",
      },
    ],
  },
  {
    type: "minesweeper",
    label: "Mijnenveger",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Minesweeper/bow",
        description: "Mijnenveger boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Minesweeper/starboard",
        description: "Mijnenveger stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Minesweeper/port",
        description: "Mijnenveger bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Minesweeper/stern",
        description: "Mijnenveger hek",
      },
    ],
  },
  {
    type: "hovercraft",
    label: "Hooverkraft",
    lightConfigurations: [
      {
        angle: "bow",
        imgSrc: "/Assets/Hovercraft/bow",
        description: "Hooverkraft boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/Hovercraft/starboard",
        description: "Hooverkraft stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/Hovercraft/port",
        description: "Hooverkraft bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/Hovercraft/stern",
        description: "Hooverkraft hek",
      },
    ],
  },
  {
    type: "ram",
    label: "Beperkt manoeuvreerbaar",
    lightConfigurations: [
      {
        angle: "around",
        imgSrc: "/Assets/RAM/bow_stationary",
        description: "Beperkt manouvreerbaar niet vaartlopend",
      },
      {
        angle: "daymark",
        imgSrc: "/Assets/RAM/daymark_stationary",
        description: "Beperkt manouvreerbaar Niet vaartlopend dagmerk",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_50m_anchored",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m ten anker boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_50m_anchored",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m ten anker stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_50m_anchored",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m ten anker bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_50m_anchored",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m ten anker hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_anchored",
        description: "Beperkt manouvreerbaar kleiner dan 50m ten anker boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_anchored",
        description: "Beperkt manouvreerbaar kleiner dan 50m ten anker stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_anchored",
        description: "Beperkt manouvreerbaar kleiner dan 50m ten anker bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_anchored",
        description: "Beperkt manouvreerbaar kleiner dan 50m ten anker hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopendbakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_50m",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m vaartlopend boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_50m",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m vaartlopend stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_50m",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m vaartlopend bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_50m",
        description: "Beperkt manouvreerbaar kleiner of groter dan 50m vaartlopend hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_stationary_starboard",
        description: "Beperkt manouvreerbaar niet vaartlopend of ten anker versperde zijde stuurboord, vrije zijde bakboord boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_stationary_starboard",
        description: "Beperkt manouvreerbaar niet vaartlopend of ten anker versperde zijde stuurboord, vrije zijde bakboord stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_stationary_starboard",
        description: "Beperkt manouvreerbaar niet vaartlopend of ten anker versperde zijde stuurboord, vrije zijde bakboord bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_stationary_starboard",
        description: "Beperkt manouvreerbaar niet vaartlopend of ten anker versperde zijde stuurboord, vrije zijde bakboord hek",
      },
      {
        angle: "daymark",
        imgSrc: "/Assets/RAM/daymark_starboard",
        description: "Dagmerk beperkt manouvreerbaar versperde zijde stuurboord, vrije zijde bakboord",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_starboard",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_starboard",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_starboard",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_starboard",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_starboard_50m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_starboard_50m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_starboard_50m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_starboard_50m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m met versperring aan stuurboord en vrije kant aan bakboord hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_stationary_port",
        description: "Beperkt manouvreerbaar Niet vaartlopend of ten anker versperde zijde bakboord , vrije zijde stuurboord boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_stationary_port",
        description: "Beperkt manouvreerbaar Niet vaartlopend of ten anker versperde zijde bakboord , vrije zijde stuurboord stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_stationary_port",
        description: "Beperkt manouvreerbaar Niet vaartlopend of ten anker versperde zijde bakboord , vrije zijde stuurboord bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_stationary_port",
        description: "Beperkt manouvreerbaar Niet vaartlopend of ten anker versperde zijde bakboord , vrije zijde stuurboord hek",
      },
      {
        angle: "daymark",
        imgSrc: "/Assets/RAM/daymark_port",
        description: "Dagmerk beperkt manouvreerbaar versperring aan bakboord en vrije kant aan stuurboord",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_port",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_port",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_port",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_port",
        description: "Beperkt manouvreerbaar kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_port_50m",
        description: "Beperkt manouvreerbaar langer of kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_port_50m",
        description: "Beperkt manouvreerbaar langer of kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_port_50m",
        description: "Beperkt manouvreerbaar langer of kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_port_50m",
        description: "Beperkt manouvreerbaar langer of kleiner dan 50m met versperring aan bakboord en vrije kant aan stuurboord hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_tug",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend met sleep <200m boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_tug",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend met sleep <200m stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_tug",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend met sleep <200m bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_tug",
        description: "Beperkt manouvreerbaar kleiner dan 50m vaartlopend met sleep <200m hek",
      },
      {
        angle: "bow",
        imgSrc: "/Assets/RAM/bow_tug_200m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m vaartlopend met sleep >200m boeg",
      },
      {
        angle: "starboard",
        imgSrc: "/Assets/RAM/starboard_tug_200m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m vaartlopend met sleep >200m stuurboord",
      },
      {
        angle: "port",
        imgSrc: "/Assets/RAM/port_tug_200m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m vaartlopend met sleep >200m bakboord",
      },
      {
        angle: "stern",
        imgSrc: "/Assets/RAM/stern_tug_200m",
        description: "Beperkt manouvreerbaar groter of kleiner dan 50m vaartlopend met sleep >200m hek",
      },
    ],
  },
];
